import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z","key":"svg-0"}],["path",{"d":"M13 15l1 1","key":"svg-1"}]]

const IconLetterQSmall = createReactComponent('outline', 'letter-q-small', 'LetterQSmall', __iconNode);

export default IconLetterQSmall;